class serviceFeesService {
  constructor(client) {
    this.apiClient = client;
  }

  async getPageableServiceFees(entityID, limit, offset, searchTerm) {
    return await this.apiClient.get("servicefees", {
      params: { entityID, limit, offset, searchTerm },
    });
  }

  async createServiceFee(entityId, serviceFeeInfo) {
    
    return await this.apiClient.post(`servicefees/${entityId}`, serviceFeeInfo, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  async updateServiceFee(entityId, serviceFeeInfo) {
    
    return await this.apiClient.put(`servicefees/${entityId}`, serviceFeeInfo, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  async deleteServiceFee(entityId, serviceFeeID) {
    return await this.apiClient.delete(`servicefees/${entityId}/${serviceFeeID}`);
  }
}

export default serviceFeesService;
